import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AppVersion } from '@core';
import { VersionConfig, VersionConfigStorage } from '../storage/version-config.storage';

@Injectable({ providedIn: 'root' })
export class UpdateService {
  private readonly storage: VersionConfigStorage = inject(VersionConfigStorage);

  isUpdated(): Observable<boolean> {
    return this.storage
      .getLoadedConfig$()
      .pipe(map((config: VersionConfig) => config.availableVersions.includes(AppVersion)));
  }

  newestVersion(): Observable<string> {
    return this.storage.getLoadedConfig$().pipe(map((config: VersionConfig) => config.newestVersion));
  }

  availableVersions(): Observable<string[]> {
    return this.storage.getLoadedConfig$().pipe(map((config: VersionConfig) => config.availableVersions));
  }
}
